import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { SoakingDto } from './soaking.dto';

export class SoakingResponseModel extends GlobalResponseObject{
    data?: SoakingDto[];
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: SoakingDto[]){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }

}
